export default __webpack_public_path__ + "static/living_moon-f810e0633f4769bb1f4d06f7cff3d80e.mp4";